define('RecipesAndEvents.Facets.Browse.View', [
    'RecipesAndEvents.View',
    'Facets.Browse.View',
    'Facets.ItemCell.View',
    'facets_items_collection.tpl',
    'facets_items_collection_view_cell.tpl',
    'facets_items_collection_view_row.tpl',
    'SC.Configuration',
    'Backbone',
    'Backbone.CollectionView',
    'Utils',
    'underscore'
], function RecipesAndEventsFacetsBrowseView(
    RecipesAndEventsView,
    FacetsBrowseView,
    FacetsItemCellView,
    facetsItemsCollectionTpl,
    facetsItemsCollectionViewCellTpl,
    facetsItemsCollectionViewRowTpl,
    Configuration,
    Backbone,
    BackboneCollectionView,
    Utils,
    _
) {
    'use strict';

    _.extend(FacetsBrowseView.prototype, {
        formatFacetTitle: _.wrap(FacetsBrowseView.prototype.formatFacetTitle, function formatFacetTitle(fn) {
            return _.unescape(fn.apply(this, _.toArray(arguments).slice(1)));
        }),
        getMetaDescription: _.wrap(FacetsBrowseView.prototype.getMetaDescription, function getMetaDescription(fn) {
            var original = fn.apply(this, _.toArray(arguments).slice(1));
            var categoryMeta = this.model && this.model.get('category') && this.model.get('category').get('description') ?
                this.model.get('category').get('pagetitle') + ': ' + this.model.get('category').get('description') :
                this.model.get('category') && this.model.get('category').get('pagetitle');
            original = original || categoryMeta || this.getTitle();
            return original;
        }),
        getResultsTitle: function getResultsTitle(word) {
            var total = this.model.get('total');
            switch (word) {
            case 'Events':
                if (total === 1) {
                    return total + ' Event';
                }
                return total + ' Events';
            case 'Recipe':
                if (total === 1) {
                    return total + ' Recipe';
                }
                return total + ' Recipes';
            default:
                if (total === 1) {
                    return total + ' Product';
                }
                return total + ' Products';
            }
        },
        showList: function showList() {
            return this.translator.options.display === 'list';
        },
        getTitle: function getTitle() {
            var facets;
            var category;
            var title;
            var buffer;
            var facet;
            var i;
            if (this.title) {
                return this.title;
            }
            facets = this.translator;
            category = this.model.get('category');
            title = category ? category.get('pagetitle') || _.pluck(this.getBreadcrumbPages(), 'text').join(' > ') : this.title;

            if (facets && facets.length) {
                buffer = [];
                facet = null;

                for (i = 0; i < facets.length; i++) {
                    facet = facets[i];
                    buffer.push(this.formatFacetTitle(facet));
                    if (i < facets.length - 1) {
                        buffer.push(facet.config.titleSeparator || ', ');
                    }
                }
                title = title ? title + ' - ' : '';
                title =
                    Configuration.get('recipesAndEvents.searchTitlePrefix', 'Applejack - Wine Spirits - ') +
                    buffer.join('') +
                    Configuration.get('recipesAndEvents.searchTitlePrefix', '');
            } else if (this.translator.getOptionValue('keywords')) {
                title = Utils.translate(
                    'Search results for "$(0)"',
                    this.translator.getOptionValue('keywords')
                );
            } else {
                title = title || Configuration.get('recipesAndEvents.defaultSearchUrl', '');
            }
            this.setMetaTwitterTitle(title);

            return title;
        },
        childViews: _.extend(FacetsBrowseView.prototype.childViews, {
            'Facets.Items': function FacetsItems() {
                var self = this;
                var displayOption = _.find(Configuration.itemsDisplayOptions, function fnFind(option) {
                    var facet = self.translator.getAllFacets() || [];
                    if (facet.length === 1 && (facet[0].value === 'Recipe' || facet[0].value === 'Events')) {
                        if (self.showList()) {
                            return option.id === 'list';
                        }
                        return option.id === 'grid_non_inventory';
                    }
                    return option.id === self.translator.getOptionValue('display');
                });

                return new BackboneCollectionView({
                    childTemplate: displayOption.template,
                    childView: FacetsItemCellView,
                    childViewOptions: {
                        application: this.application
                    },
                    viewsPerRow: parseInt(displayOption.columns, 10),
                    collection: this.model.get('items'),
                    cellTemplate: facetsItemsCollectionViewCellTpl,
                    rowTemplate: facetsItemsCollectionViewRowTpl,
                    template: facetsItemsCollectionTpl,
                    context: {
                        keywords: this.translator.getOptionValue('keywords')
                    }
                });
            },
            'RecipesAndEventsView': function RecipesAndEventsChildView() {
                var categoriesExcluded = Configuration.get('recipesAndEvents.commerceCategoriesExcluded') || ['6'];
                var categoryId = this.model && this.model.get('category') && this.model.get('category').get('internalid');
                var isExcludedCat;
                if (categoriesExcluded && categoriesExcluded.length && categoryId &&
                    categoriesExcluded.indexOf(categoryId) >= 0) {
                    isExcludedCat = true;
                }

                return new RecipesAndEventsView({
                    application: this.application,
                    isExcludedCat: isExcludedCat
                });
            }
        }),
        getContext: _.wrap(FacetsBrowseView.prototype.getContext, function getContext(fn) {
            var item = this.model.get('items');
            var itemType = item && item.models && item.models[0] ? item.models[0].get('custitem_item_type') : 'Product';
            var originalContext = fn.apply(this, _.toArray(arguments).slice(1));
            var url = Backbone.history.fragment;
            originalContext.isItem = (this.model && this.model.options && this.model.options.data &&
                this.model.options.data.custitem_item_type === 'Item') ||
                url.indexOf('custitem_item_type/Item') > -1 || url.indexOf('custitem_item_type=Item') > -1;
            originalContext.isItem = originalContext.isItem || (url.indexOf('custitem_item_type') < 0 && url.indexOf('custitem_item_type/Item') < 0);
            originalContext.itemType = this.getResultsTitle(itemType);
            originalContext.hasCategory = this.model && this.model.get('category') &&
                !this.model.get('category').isNew();
            originalContext.categoryName = this.model && this.model.get('category') &&
                this.model.get('category').get('pagetitle');
            return originalContext;
        })
    });
});
